$(document).ready(function () {

    sideNavAccordions.inst = new logicjs.rtAccordions({
        container: ".side-nav",
        accordionsClass: ".nav-item--accordion",
        accordionCtrlTarget: ".nav-item__toggle-ctrl",
        hiddenClass: "nav-item--closed",
        accordionView: ".side-nav__sub-menu",
        loadingClass: "loading",
        loadActiveClass: "nav-item--open",
        activeClass: "active",
        storeOpenCookie: {
            name: "NavAccordionExpandedList",
            attr: "data-tab-name"
        },
        toggleAccordions: true,
        toggleCallback: sideNavAccordions.toggleCallback,
        setAccordionHeights: false,
        disableAccordionClick: false
    });
    sideNav.init();

});

// The functionality for the site navigation side bar, and the sub-navigation dropdowns consisted within
var sideNav = {};

sideNav.bind = function () {
    sideNav.windowOnLoad();
    sideNav.menuToggleAddclickEvents();
    //sideNav.nestedSubMenuToggle();
    //sideNav.bindSubMenuEvent();
    sideNav.menuToggleAddWindowResizeEvent();
};

sideNav.runAnimEvents = function () {
    document.dispatchEvent(sideNav.events.navStartAnimation);
    setTimeout(function () {
        document.dispatchEvent(sideNav.events.navEndAnimation);
    }, 300);
};

sideNav.menuOpen = function () {

    for (var i = 0; i < sideNav.menuToggleContainer.length; i++) {
        sideNav.menuToggleContainer[i].classList.remove('menu-toggle--closed');
        sideNav.menuToggleContainer[i].classList.add('menu-toggle--open');
    }

    sideNav.hideAnimationOverflow('out');

    sideNav.sideNavContainer.classList.remove("outer-wrapper-aside--closed");
    sideNav.sideNavContainer.classList.add("outer-wrapper-aside--open");
    sideNav.outerPage.classList.remove("outer-page--side-menu-closed");
    sideNav.outerPage.classList.add("outer-page--side-menu-open");

    sideNav.setNavExpandedCookies(true);

    sideNavAccordions.inst.changeOpt("toggleAccordions", false);
    sideNavAccordions.inst.changeOpt("disableAccordionClick", false);
    if (sideNavScroll.inst) {
        sideNavScroll.inst.setInitFns(true);
        sideNavScroll.inst.changeOpt("fixAlt", true);
    }
};

sideNav.menuClose = function () {
    for (var i = 0; i < sideNav.menuToggleContainer.length; i++) {
        sideNav.menuToggleContainer[i].classList.remove('menu-toggle--open');
        sideNav.menuToggleContainer[i].classList.add('menu-toggle--closed');
    }

    sideNav.hideAnimationOverflow('in');
    sideNav.sideNavContainer.classList.remove("outer-wrapper-aside--open");
    sideNav.sideNavContainer.classList.add("outer-wrapper-aside--closed");
    sideNav.outerPage.classList.remove("outer-page--side-menu-open");
    sideNav.outerPage.classList.add("outer-page--side-menu-closed");

    sideNav.setNavExpandedCookies(false);

    sideNavAccordions.inst.changeOpt("toggleAccordions", true);
    sideNavAccordions.inst.changeOpt("disableAccordionClick", true);
    if (sideNavScroll.inst) {
        sideNavScroll.inst.setInitFns(true);
        sideNavScroll.inst.changeOpt("fixAlt", false);
    }
};

sideNav.setNavExpandedCookies = function (isExpanded) {
    logicjs.setCookie('NavExpandedState', (isExpanded && window.matchMedia("(min-width: 1025px)").matches), {
        expires: 7,
        path: '/'
    });
    if (window.matchMedia("(max-width: 1024px)").matches) return;//don't save
    logicjs.setCookie('ExpandedAt1024', isExpanded, {
        expires: 7,
        path: '/'
    });
}

sideNav.menuToggleAddWindowResizeEvent = function () {
    window.addEventListener('resize', function () {
        sideNav.windowResize();
    }, true);
};

sideNav.windowResize = function () {
    if (window.matchMedia) {
        if (window.matchMedia("(max-width: 1024px)").matches) sideNav.menuToggleHide();
        else if (sideNav.isExpandedAt1024()) sideNav.menuToggleShow();
    }
};

sideNav.isExpandedAt1024 = function () {
    if (logicjs.getCookie('ExpandedAt1024') == '') return true;
    return logicjs.getCookie('ExpandedAt1024') == "true";
}

sideNav.hideAnimationOverflow = function (dir) {
    sideNav.sideNavInnerContainer.classList.add(sideNav.containerAnimClass);
    switch (dir) {
        case "in": sideNav.sideNavInnerContainer.classList.add(sideNav.containerAmimInClass); break;
        case "out": sideNav.sideNavInnerContainer.classList.add(sideNav.containerAmimOutClass); break;

    }
    setTimeout(function () {
        sideNav.sideNavInnerContainer.classList.remove(sideNav.containerAnimClass);
        sideNav.sideNavInnerContainer.classList.remove(sideNav.containerAmimInClass);
        sideNav.sideNavInnerContainer.classList.remove(sideNav.containerAmimOutClass);
    }, 500); //same as transition
};

sideNav.menuToggleShow = function () {
    sideNav.menuOpen();
};

sideNav.menuToggleHide = function () {
    sideNav.menuClose();
};

sideNav.menuToggleAddclickEvents = function () {
    for (var i = 0; i < sideNav.menuToggleContainer.length; i++) {
        sideNav.menuToggleContainer[i].addEventListener('click', function (e) {
            e.preventDefault();
            if (sideNav.sideNavContainer.classList.contains('outer-wrapper-aside--open')) {
                document.dispatchEvent(sideNav.events.navClose);
                sideNav.runAnimEvents();
                sideNav.menuToggleHide();
            }
            else {
                document.dispatchEvent(sideNav.events.navOpen);
                sideNav.runAnimEvents();
                sideNav.menuToggleShow();
            }
        });
    }
};

sideNav.nestedSubMenuToggle = function () {
    for (var i = 0; i < sideNav.subMenuToggle.length; i++) {
        sideNav.subMenuToggle[i].addEventListener('click', function (e) {
            sideNav.nestedSubMenu = this.querySelector("." + sideNav.nestedSubMenuClass);
            if (sideNav.nestedSubMenu.classList.contains('active')) {
                sideNav.nestedSubMenu.classList.remove("active");
                this.classList.remove("active");
            } else {
                sideNav.nestedSubMenu.classList.add("active");
                this.classList.add("active");
            }
        });
    }
};

sideNav.bindSubMenuEvent = function () {
    for (var i = 0; i < sideNav.subMenuToggle.length; i++) {
        sideNav.subMenuToggle[i].addEventListener('mouseover', function (e) {
            console.log(window.innerHeight);
            sideNav.nestedSubMenu = this.querySelector("." + sideNav.nestedSubMenuClass);
            console.log(sideNav.nestedSubMenu.getBoundingClientRect());
            if (!sideNav.isBottomInView(sideNav.nestedSubMenu)) {
                sideNav.nestedSubMenu.classList.add("hi");
                var diff = sideNav.nestedSubMenu.getBoundingClientRect().height - window.innerHeight;
                var height = window.innerHeight - diff - document.querySelector(".outer-wrapper-header").clientHeight;
                sideNav.nestedSubMenu.style.height = height + "px";
            }
        });
        sideNav.subMenuToggle[i].addEventListener('mouseleave', function (e) {
            sideNav.nestedSubMenu = this.querySelector("." + sideNav.nestedSubMenuClass);
            sideNav.nestedSubMenu.classList.remove("hi");
            sideNav.nestedSubMenu.style.height = "";
        });
    }
};

sideNav.isBottomInView = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
};

sideNav.windowOnLoad = function () {

    // NEED TO REMOVE THIS IN THE HARD-CODE
    if (sideNav.outerPage.classList.contains('outer-page--onload')) {
        sideNav.outerPage.classList.remove('outer-page--onload');
    }
};

sideNav.compareNavAndMain = function (main) {
    if (main.clientHeight < window.innerHeight + window.pageYOffset) {
        if (sideNavScroll.inst) sideNavScroll.inst.setInitFns();
        sideNav.mainContentResizeObserver.unobserve(sideNav.mainContent);
        sideNav.mainContentSizeListener();
    }
};

sideNav.mainContentSizeListener = function () {
    sideNav.mainContent = document.getElementsByClassName('outer-wrapper-content')[0];
    sideNav.mainContentResizeObserver = new ResizeObserver(function (entries) {
        sideNav.compareNavAndMain(entries[0].target);
    });
    sideNav.mainContentResizeObserver.observe(sideNav.mainContent);
};

sideNav.loadCheck = function () {
    if (sideNav.sideNavContainer.classList.contains(sideNav.containerClassActive)) {
        sideNavAccordions.inst.changeOpt("toggleAccordions", false);
    }
    sideNav.windowResize();
};

sideNav.buildEvents = function () {
    var objSettings = {
        bubbles: true,
        detail: {
            animationTime: 300
        }
    };

    sideNav.events = {
        navOpen: new CustomEvent('rt_side_nav_open', objSettings),
        navClose: new CustomEvent('rt_side_nav_close', objSettings),
        navStartAnimation: new CustomEvent('rt_side_nav_start_animation', objSettings),
        navEndAnimation: new CustomEvent('rt_side_nav_end_animation', objSettings)
    };
};

sideNav.init = function () {
    sideNav.buildEvents();

    sideNav.sideNavClass = "side-nav";
    sideNav.subMenuClass = sideNav.sideNavClass + "__sub-menu";
    sideNav.nestedSubMenuClass = sideNav.sideNavClass + "__child-sub-menu-items";
    sideNav.nestedSubMenuBtnClass = sideNav.sideNavClass + "__child-sub-menu-expand-button";

    sideNav.navItemAccordionClass = "nav-item--accordion";
    // sideNav.containerMarginleftStyle = "-280px";
    sideNav.containerClass = "outer-wrapper-aside";
    sideNav.innerContainerClass = "outer-wrapper-aside__inner-container";
    sideNav.containerAnimClass = "outer-wrapper-aside--animating";
    sideNav.containerAmimInClass = "outer-wrapper-aside--animating-in";
    sideNav.containerAmimOutClass = "outer-wrapper-aside--animating-out";
    sideNav.containerClassActive = sideNav.containerClass + "--open";

    if (document.getElementsByClassName(sideNav.subMenuClass).length > 0) {
        sideNav.menuToggleContainer = document.getElementsByClassName('menu-toggle');
        sideNav.subMenuToggle = document.getElementsByClassName(sideNav.nestedSubMenuBtnClass);
        sideNav.menuToggles = $('.menu-toggle');
        sideNav.sideNavContainer = document.getElementsByClassName(sideNav.containerClass)[0];
        sideNav.sideNavInnerContainer = document.getElementsByClassName(sideNav.innerContainerClass)[0];

        sideNav.navItem = $('.nav-item');
        sideNav.outerPage = document.getElementsByClassName('outer-page')[0];

        sideNav.sideNavList = document.getElementsByClassName(sideNav.sideNavClass)[0];
        sideNav.subMenu = document.getElementsByClassName(sideNav.subMenuClass);

        sideNav.bind();
        sideNav.loadCheck();
        sideNav.mainContentSizeListener();
    }
};

